import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import fetchApi from "api/fetchApi";
import useCreateGoalMutation from "hooks/mutations/useCreateGoalMutation";
import useCreateReviewMutation from "hooks/mutations/useCreateReview";
import { useGetGoals } from "hooks/queries/useGetGoals";
import { useSnackbar } from "hooks/useSnackbar";
import IKeyPerformanceArea from "models/KeyPerformanceArea";
import React, { forwardRef, useEffect, useState } from "react";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IGoalFormProps {
  goalFormOpen: boolean;
  handleGoalFormClose: () => void;
}

const GoalForm = ({ goalFormOpen, handleGoalFormClose }: IGoalFormProps) => {
  const theme = useTheme();
  const { showSnackbar, getSnackbarProps } = useSnackbar();
  const [keyPerformanceArea, setKeyPerformanceArea] = useState("");
  const [keyPerformanceIndicator, setKeyPerformanceIndicator] = useState("");
  const [keyPerformanceAreaOption, setKeyPerformanceAreaOption] = useState<IKeyPerformanceArea[]>(
    []
  );
  // const [review,setReview] = useState("");
  const { refetch } = useGetGoals();
  const { mutate: createGoal } = useCreateGoalMutation({ callback: () => refetch(), showSnackbar });
  const { mutate: createReview } = useCreateReviewMutation({
    callback: () => refetch(),
    showSnackbar,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchApi(`kpas`).get("");
        if (response.success) {
          setKeyPerformanceAreaOption(response.data.items);
        } else {
          console.log("Failed to fetch key performance areas");
        }
      } catch (error) {
        console.log("An error occurred while fetching strategic domains", error);
      }
    };

    fetchData();
  }, []);

  const handleCancel = () => {
    setKeyPerformanceArea("");
    setKeyPerformanceIndicator("");
    handleGoalFormClose();
  };

  const handleAddGoal = async () => {
    const newGoal = {
      kpas_id: keyPerformanceArea,
      title: keyPerformanceIndicator,
    };


    const newReview = {
      form_name: "Manager Assessment Form with Ratings",
      author_dueDate: "2023-09-28T10:16:59",
    };

    createGoal(newGoal);
    createReview(newReview);

    handleCancel();
  };

  return (
    <>
      <Dialog
        open={goalFormOpen}
        onClose={handleGoalFormClose}
        TransitionComponent={Transition}
        keepMounted
        maxWidth="sm"
        fullWidth
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <Typography
            variant="h4"
            sx={{ fontSize: "24px", color: theme.palette.primary.main, fontWeight: 800 }}
          >
            Create Goal
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography
              variant="h4"
              sx={{ fontSize: "18px", color: theme.palette.primary.main, fontWeight: 800 }}
            >
              General information
            </Typography>
          </DialogContentText>
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 3,
              mb: 1,
            }}
          >
            Key Performance Area
          </Typography>
          <FormControl fullWidth>
            <InputLabel id="strategicDomain-label">Select Key Performance Area</InputLabel>
            <Select
              labelId="keyPerformanceArea-label"
              id="keyPerformanceArea"
              value={keyPerformanceArea}
              onChange={(e) => setKeyPerformanceArea(e.target.value)}
              label="Key Perfromance Area"
              sx={{ mb: 1 }}
            >
              {keyPerformanceAreaOption.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 2,
              mb: 1,
            }}
          >
            Key Performance Indicator
          </Typography>
          <TextField
            autoFocus={true}
            autoComplete="off"
            id="keyPerformanceIndicator"
            label="Enter Key Performance Indicator"
            placeholder="Enter Key Performance Indicator"
            fullWidth
            sx={{ mb: 1 }}
            value={keyPerformanceIndicator}
            onChange={(e) => setKeyPerformanceIndicator(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ mt: 2 }}>
          <Button variant="outlined" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" type="submit" onClick={handleAddGoal}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        {...getSnackbarProps()}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={4000}
      >
        <Alert {...getSnackbarProps()}>{getSnackbarProps().message}</Alert>
      </Snackbar>
    </>
  );
};

export default GoalForm;
